/* services */
import SelosService from "@/services/Registros/SelosService"

const pegarOsPorStatusDosSelos = async (statusDoSelo = null) => {
  try {
    const osFiltradasPorStatusDosSelos = {
      somaDosSelosDasOs: 0,
      os: null,
      lastPage: 1,
      ordemServicoId: null,
      selosDaMesmaOs: false
    }

    let payload = {
      page: 1,
      perPage: 15,
    }

    if (statusDoSelo === 'selos_nao_enviados') {
      payload = {
        ...payload,
        numero: null,
        data_cumprida: null,
        status_selos: statusDoSelo
      }
    }

    const { data, lastPage, total } = await SelosService.getSelosNaoEnviados(payload)
    //return total
    // Método antigo:
    osFiltradasPorStatusDosSelos.somaDosSelosDasOs = total // data.reduce((acc, os) => acc + os.itens[0].seloItemOs.length, 0)
    osFiltradasPorStatusDosSelos.os = data
    osFiltradasPorStatusDosSelos.lastPage = lastPage
    osFiltradasPorStatusDosSelos.ordemServicoId = osFiltradasPorStatusDosSelos?.os.length === 1 ? osFiltradasPorStatusDosSelos?.os[0].ordem_servico_id : null

    if (data.length === 1) osFiltradasPorStatusDosSelos.selosDaMesmaOs = true
    else osFiltradasPorStatusDosSelos.selosDaMesmaOs = false

    return osFiltradasPorStatusDosSelos
  } catch (error) {
    console.log(error)
  }
}

export default pegarOsPorStatusDosSelos
